<template>
  <div style="height: 400px; width: 100%" ref="chart" id="main"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import '@jdcloud/jelement-echart'
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
} from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
echarts.use([
  LegendComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
])
export default {
  props: {
    xAxisData: {
      type: Array,
      required: true,
    },
    yAxisData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      myChart: undefined,
      resizeObserver: null,
    }
  },
  methods: {
    init() {
      const option = {
        legend: {
          data: ['图例1'],
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(44,104,255,0.04)',
            },
          },
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: this.yAxisData,
            type: 'bar',
          },
        ],
      }
      //页面加载完容器再渲染页面
      this.$nextTick(() => {
        this.myChart = echarts.init(this.$refs.chart, 'jelement')
        this.myChart.setOption(option)
        // 监听窗口大小变化事件，以便在窗口大小变化时调整图表大小
        window.addEventListener('resize', this.handleResize)
        // 创建一个ResizeObserver实例来监听父元素的尺寸变化
        this.resizeObserver = new ResizeObserver(() => {
          // 在这里，我们不需要entries参数，因为我们知道是哪个元素的尺寸在变化
          // 但是你可以使用entries参数来获取更多信息，比如元素的新尺寸等
          if (this.myChart) {
            this.myChart.resize()
          }
        })
        // 开始监听父元素的尺寸变化
        this.resizeObserver.observe(document.querySelector('#billOverview'))
      })
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
  },
  mounted() {
    this.init()
  },
  watch: {
    xAxisData: {
      handler: 'init',
      deep: true, // 如果需要深度监听对象内部的变化，设置为 true
    },

    yAxisData: {
      handler: 'init',
      deep: true, // 如果需要深度监听对象内部的变化，设置为 true
    },
  },

  beforeDestroy() {
    this.myChart = undefined
    // 停止监听尺寸变化并断开所有被观察者的连接
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }

    // 销毁ECharts实例
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
}
</script>
